import GuideSourceType from '@alltrails/amplitude/enums/GuideSourceType';
import { LocationDetailsResponseType } from '@/types/locationDetailsPages/shared';

export const getGuideSourceType = (type?: LocationDetailsResponseType): GuideSourceType => {
  switch (type) {
    case 'park':
      return 'park page';
    default:
      return 'location page';
  }
};
